export default "__VITE_ASSET__257e41c2__"